import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Empresa } from 'src/app/core/Interfaces/vacantes/empresa.interface';
import { VacanteResumen } from 'src/app/core/Interfaces/vacantes/vacante-resumen.interface';
import { AuthApiService } from 'src/app/core/services/auth-api-service';
import { SearchJobApiService } from 'src/app/core/services/search-job-api.service';
import { VacantesResultados, Vacantes, VacanteInfo } from "src/app/core/Interfaces/vacantes/vacantes-resultado.interface";
import { CandidatosApiService } from 'src/app/core/services/candidatos-api.service';

@Component({
  selector: 'app-vacante',
  standalone: false,
  templateUrl: './postulacion.component.html',
  styleUrl: './postulacion.component.scss'
})
export class PostulacionComponent implements OnInit {

  selectedJobOpenning: string = '';
  isLoggedIn$ = this.authApiService.isLoggedIn();
  isLoggedIn: boolean = false;
  jobOpeningSelected: VacanteInfo = {} as VacanteInfo;
  listJobOpening: Vacantes[] = [];
  businessInfo: Empresa | null = null;
  pasos = ['Datos Personales', 'Dirección', 'Método de Pago', 'Confirmación'];
  pasoActual = 1;
  puedeAvanzar = false;

  constructor(private route: ActivatedRoute, private router: Router,
    private authApiService: AuthApiService,
    private searchJobApiService: SearchJobApiService,
    private candidatosApiService: CandidatosApiService) {

  }

  ngOnInit(): void {
    this.isLoggedIn$.subscribe(value => this.isLoggedIn = value);

    this.selectedJobOpenning = this.route.snapshot.paramMap.get("id") || '';
    if (!this.selectedJobOpenning) {
      this.router.navigate(['/']).then(() => {
        window.location.reload();
      });
    } else {
      //this.findJobOpening();
      this.jobOpeningSelected = JSON.parse(localStorage.getItem('jobSelected') || '{}');
    }
    if(this.isLoggedIn) {
      this.postulacionCandidatos();
    }
  }

  findJobOpening() {
    this.searchJobApiService.getVacantesRequisicion(Number(this.selectedJobOpenning)).subscribe(data => {
      let _vacantesResultado: any = data.hits;
      let _vacantesHits: any = _vacantesResultado.hits;
      let _vacantes: Vacantes[] = _vacantesHits;
      this.jobOpeningSelected = _vacantes[0]._source;
      this.findBusinessInfo();
    });
  }
  findBusinessInfo() {
    this.searchJobApiService.getEmpresaPorId(this.selectedJobOpenning!).subscribe(data => {
      setTimeout(() => {
        this.businessInfo = data;

      })
    }
    );
  }

  actualizarPaso(nuevoPaso: number) {
    this.pasoActual = nuevoPaso;
  }
  validarPasoActual() {
    if (this.pasoActual === 1) {
      const nombre = (document.getElementById('name') as HTMLInputElement)?.value;
      this.puedeAvanzar = !!nombre;
    } else {
      this.puedeAvanzar = true; // En el último paso, siempre se puede avanzar
    }
  }

  mensajePostulacion = '';
  isError = false;
  postulacionCandidatos() {
    this.isError = false;
    console.log("this.vacante", this.jobOpeningSelected);

    console.log("this.selectedJobOpenning", typeof this.selectedJobOpenning === 'object' ? JSON.stringify(this.selectedJobOpenning) : this.selectedJobOpenning);
    console.log(
      "this.jobOpeningSelected.name",
      typeof this.jobOpeningSelected.name === 'object'
        ? JSON.stringify(this.jobOpeningSelected.name)
        : this.jobOpeningSelected.name
    );

    // Usar el ID de la vacante seleccionada desde Appian
    const vacanteId = Number(this.jobOpeningSelected.id || this.selectedJobOpenning);
    // Por ahora usamos un ID temporal para el candidato, esto debería venir del sistema de autenticación

    const candidatoId: string | null = localStorage.getItem('candidatoId'); // Este valor debe ser obtenido del usuario logueado

    this.candidatosApiService.postularCandidato(vacanteId, Number(candidatoId)).subscribe(
      (data: any) => {
        this.mensajePostulacion = data; //'¡Tu postulación fue exitosa!';
      }, (error: any) => {
        console.error(error);
        this.mensajePostulacion = 'Hubo un error al procesar tu postulación. Por favor, intenta nuevamente más tarde.';
        this.isError = true;
      }
    );
  }

  // Métodos helper para procesar datos de Appian
  getSueldo(): string {
    if (this.jobOpeningSelected.ocultar_sueldo) {
      return 'Sueldo competitivo';
    }
    
    const min = this.jobOpeningSelected.sueldo_min;
    const max = this.jobOpeningSelected.sueldo_mx;
    
    if (min && max) {
      return `${min} - ${max}`;
    } else if (min) {
      return `Desde ${min}`;
    } else if (max) {
      return `Hasta ${max}`;
    }
    
    return this.jobOpeningSelected.sueldo_rango || 'A convenir';
  }

  getCategoria(): string {
    return this.jobOpeningSelected.categoria || 
           this.jobOpeningSelected.linea_negocio || 
           'General';
  }

  getUbicacion(): string {
    try {
      if (this.jobOpeningSelected.ubicacion) {
        const ubicacion = typeof this.jobOpeningSelected.ubicacion === 'string' 
          ? JSON.parse(this.jobOpeningSelected.ubicacion) 
          : this.jobOpeningSelected.ubicacion;
        
        const partes = [];
        if (ubicacion.ciudad) partes.push(ubicacion.ciudad);
        if (ubicacion.region) partes.push(ubicacion.region);
        if (ubicacion.pais) partes.push(ubicacion.pais);
        
        return partes.length > 0 ? partes.join(', ') : 'México';
      }
    } catch (e) {
      console.warn('Error parsing ubicacion:', e);
    }
    
    // Fallback para estructura anterior
    if (this.jobOpeningSelected.entidad_federativa && this.jobOpeningSelected.pais) {
      return `${this.jobOpeningSelected.entidad_federativa}, ${this.jobOpeningSelected.pais}`;
    }
    
    return 'México';
  }

  getFechaPublicacion(): string {
    if (this.jobOpeningSelected.createdOn) {
      return new Date(this.jobOpeningSelected.createdOn).toLocaleDateString('es-ES');
    }
    return this.jobOpeningSelected.fecha_publicacion || 'Recientemente';
  }

  getTipoContratacion(): string {
    const tipos = {
      1: 'Tiempo completo',
      2: 'Tiempo parcial', 
      3: 'Por proyectos',
      4: 'Temporal',
      5: 'Prácticas'
    };
    
    const tipoId = this.jobOpeningSelected.tipo_contratacion;
    return tipos[tipoId as keyof typeof tipos] || 
           this.jobOpeningSelected.tipo_contratacion_mp ||
           'No especificado';
  }

  getLugarTrabajo(): string {
    const lugares = {
      1: 'Presencial',
      2: 'Remoto',
      3: 'Híbrido'
    };
    
    const lugarId = this.jobOpeningSelected.lugar_trabajo;
    return lugares[lugarId as keyof typeof lugares] || 'Presencial';
  }

  getHorarioTrabajo(): string {
    const horarios = {
      1: 'Tiempo completo',
      2: 'Tiempo parcial',
      3: 'Fines de semana',
      4: 'Nocturno'
    };
    
    const horarioId = this.jobOpeningSelected.horario_trabajo;
    return horarios[horarioId as keyof typeof horarios] || 
           `${this.jobOpeningSelected.horario || '8'} hrs` ||
           'Tiempo completo';
  }

  getEscolaridad(): string {
    const escolaridades = {
      1: 'Sin estudios',
      2: 'Bachillerato',
      3: 'Licenciatura',
      4: 'Maestría',
      5: 'Doctorado'
    };
    
    const escolaridadId = this.jobOpeningSelected.escolaridad;
    return escolaridades[escolaridadId as keyof typeof escolaridades] || 'Bachillerato';
  }

  getIdiomas(): string {
    if (this.jobOpeningSelected.idiomas) {
      return this.jobOpeningSelected.idiomas;
    }
    return '';
  }
}
